import styled from 'styled-components'
import { theme } from '@/client/components'
import borders from '@/client/components/theme/borders'
import breakpoint from '@/client/components/theme/breakpoint'
import color from '@/client/components/theme/color'
const { space } = theme

export const ContactForm = styled.div`
  background-color: ${color.grayscale.lighter};
  padding: ${space.xl2};
  border-radius: 0 ${space.xl4} 0 0;
  margin-right: 0;
  margin-bottom: ${space.xl};

  .personName .Legend {
    padding: 80px;
  }

  & .checkbox-desc-box {
    line-height: 1.4;
    color: ${color.grayscale.dark};
    margin-bottom: ${space.lg};

    @media (min-width: ${breakpoint.lg2}) {
      margin-bottom: ${space.xs};
    }
  }

  .modal {
    opacity: 1;
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .modal-hidden {
    opacity: 0;
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  @media (min-width: ${breakpoint.hd}) {
    margin-right: ${space.lg};
    margin-bottom: 0;
  }
`

export const FieldList = styled.div<{ fullWidth?: boolean; isAu?: boolean }>`
  gap: ${space.lg};
  display: grid;

  @media (min-width: ${breakpoint.lg}) {
    grid-template-columns: ${({ fullWidth }) => (fullWidth ? '100%' : 'repeat(2, 1fr)')};

    ${({ isAu }) =>
      !isAu &&
      `
      & > *:nth-child(3n) {
        grid-column: 1 / -1; /* Span every third item across all columns */
      }
    `}

    & > .company_au,
    & > .address1_au,
    & > .country_au {
      grid-column: 1 / -1;
    }

    & #BrancheId,
    & #Title,
    & #Country {
      height: 2.2rem;
    }

    & #StateId {
      height: 2.3rem;
    }

    & input,
    select {
      font-size: 0.8375rem;
    }
  }
`

export const FieldsetActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space.lg};

  & #refreshButton {
    border-radius: 2rem;
    border: 2px solid #c4c4c4;
    padding-left: 0;
    gap: 2rem;
    justify-content: flex-start;

    & .icon {
      font-size: 2.5rem;
    }
  }

  @media (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0;
  }
`

export const SideBoxWrapper = styled.div`
  display: inline-grid;
  gap: ${space.xl};

  @media (min-width: ${breakpoint.lg2}) {
    width: 85%;
    margin-left: ${space.md};
  }
`

export const FirstSideBox = styled.div`
  padding: ${space.md};
  border: 2px solid ${color.grayscale.lighter};
  border-radius: ${borders.radius.xl};

  .iconCheckmark {
    align-self: auto;
    vertical-align: sub;
  }

  .gifImage {
    max-width: 100%;
  }
`

export const headingAligner = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${space.xl};
`

export const SecondSideBox = styled.div`
  padding: ${space.lg} 0 ${space.lg} ${space.lg};
  background-color: ${color.grayscale.lightBlue};
  border-radius: ${borders.radius.xl};

  .button {
    border-radius: ${space.xl};
    height: 35px;
    padding: 0 0.5rem;
  }

  .proofLink {
    display: flex;
    width: 100%;
    gap: ${space.md};
  }
`

export const ImageAligner = styled.div`
  @media (min-width: ${breakpoint.lg}) {
    display: grid;
    grid-template-columns: auto;
    .proofImage {
      grid-area: 1 / 2 / span 3 / span 4;
    }
  }
`
export const ProofButtonWrapper = styled.div`
  padding-top: ${space.md};
  display: flex;
`
